import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgPaymentIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M.01 3.05v10h16v-10h-16ZM14.76 4.3v1.95H1.26V4.3h13.5Zm-13.5 7.5V7.5h13.5v4.3H1.26Z",
    fill: "currentColor"
  }));
}

export { SvgPaymentIcon as default };
